import request from 'lmcv/utils/axios'
import { API_ENDPOINTS } from 'lmcv/modules/endpoints'

export const getProfessional = async () => {
  const response = await request
    .get(API_ENDPOINTS.professional)
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}
